import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

export const putAutonomoContatoEmergencia = async (params: {
  idAutonomo: string;
  nomeEmergencia: string;
  telefoneEmergencia: string;
  authToken: string;
}): Promise<any> => {
  const url = "/api/autonomo/AlterarContatoEmergencia";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.put(url, parameters, config);
  return response?.data;
};
